import { render, staticRenderFns } from "./WebAuthnButton.vue?vue&type=template&id=1160a2d7"
import script from "./WebAuthnButton.vue?vue&type=script&lang=js"
export * from "./WebAuthnButton.vue?vue&type=script&lang=js"
import style0 from "./WebAuthnButton.vue?vue&type=style&index=0&id=1160a2d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports